import React, {useState} from 'react'
import {IoIosArrowBack} from 'react-icons/io'
import {IoIosArrowForward} from 'react-icons/io'
import Popover from '@material-ui/core/Popover'

export default function HeaderCalendar({value, setValue}) {
  const [monthHover, setMonthHover] = useState(false)
  const [yearHover, setYearHover] = useState(false)
  const monthNames = [
    'January',
    'July',
    'February',
    'August',
    'March',
    'September',
    'April',
    'October',
    'May',
    'November',
    'June',
    'December',
  ]
  const [anchorMonth, setAnchorMonth] = React.useState(null)
  const [anchorYear, setAnchorYear] = React.useState(null)
  const openMonth = Boolean(anchorMonth)
  const openYear = Boolean(anchorYear)
  const [currentYear, setCurrentYear] = useState(value.clone().format('YYYY'))
  const id = openMonth || openYear ? 'simple-popover' : undefined

  const clickMonth = event => {
    setAnchorMonth(event.currentTarget)
  }

  const clickYear = event => {
    setAnchorYear(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorMonth(null)
    setAnchorYear(null)
  }

  const valueClick = (dataValue, event) => {
    setValue(dataValue)
    handleClose()
  }

  function currMonth() {
    return value.format('MMMM')
  }

  function currYear() {
    return value.format('YYYY')
  }

  function prevMonth() {
    return value.clone().subtract(1, 'month')
  }

  function nextMonth() {
    return value.clone().add(1, 'month')
  }

  function prevYear() {
    return parseInt(currentYear) - 12
  }

  function nextYear() {
    return parseInt(currentYear) + 12
  }

  return (
    <div className="header">
      <div className="current">
        <div
          className={monthHover ? 'calendarHover cursor_pointer' : 'cursor_pointer'}
          onMouseEnter={() => setMonthHover(true)}
          onMouseLeave={() => setMonthHover(false)}
          onClick={e => clickMonth(e)}
        >
          {currMonth()}
        </div>
        <div
          className={yearHover ? 'calendarHover cursor_pointer' : 'cursor_pointer'}
          onMouseEnter={() => setYearHover(true)}
          onMouseLeave={() => setYearHover(false)}
          style={{width: '56px', textAlign: 'left', padding: '2px'}}
          onClick={e => clickYear(e)}
        >
          {currYear()}
        </div>
      </div>
      <div className="previous cursor_pointer" onClick={() => setValue(prevMonth())}>
        <IoIosArrowBack />
      </div>
      <div className="next cursor_pointer" onClick={() => setValue(nextMonth())}>
        <IoIosArrowForward />
      </div>

      <Popover
        id={id}
        open={openMonth}
        anchorEl={anchorMonth}
        onClose={handleClose}
        PaperProps={{style: {borderRadius: '12px'}}}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className="popupMonthSize">
          {monthNames.map(month => (
            <div
              onClick={e => valueClick(value.clone().month(month), e)}
              style={{backgroundColor: month === value.format('MMMM') ? '#ebf2ff' : ''}}
              className="monthStyles cursor_pointer"
            >
              <div className="popupMonthMoment">{month}</div>
            </div>
          ))}
        </div>
      </Popover>

      <Popover
        id={id}
        open={openYear}
        anchorEl={anchorYear}
        onClose={handleClose}
        PaperProps={{style: {borderRadius: '12px', height: '290px'}}}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div className="popupYearSize">
          <div className="yearArrow" style={{gridColumn: '1/3'}}>
            <div className="yearIconPrev cursor_pointer" onClick={() => setCurrentYear(prevYear())}>
              <IoIosArrowBack />
            </div>
            <div className="yearIconNext cursor_pointer" onClick={() => setCurrentYear(nextYear())}>
              <IoIosArrowForward />
            </div>
          </div>
          {[0, 6, 1, 7, 2, 8, 3, 9, 4, 10, 5, 11].map(index => {
            const year = parseInt(currentYear) + index
            return (
              <div
                onClick={e => valueClick(value.clone().year(year), e)}
                className="popupYearMoment cursor_pointer"
                style={{
                  backgroundColor: year.toString() === value.format('YYYY') ? '#ebf2ff' : '',
                }}
              >
                {year}
              </div>
            )
          })}
        </div>
      </Popover>
    </div>
  )
}
